import React from 'react';

const EmitterContext = React.createContext();
export default EmitterContext;